export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/kMIconOrange.693c3f24.svg","height":18,"width":22,"blurWidth":0,"blurHeight":0};